import { useState, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import EditorInput from "layouts/Flow Designer/components/ComponentActionsGenerator/components/EditorInput";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { EditorExpansion } from "../../../../EditorExpansion";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import { useDebouncer } from "hooks/useDebouncer";

const PayloadEditor = ({ isFlowActive, allowEditWorkflow }) => {
  const [editorExpanded, setEditorExpanded] = useState(false);
  const formRef = useContext(FormFieldsContext);
  const [editorValue, setEditorValue] = useState(formRef?.values?.payload);
  const { debouncer } = useDebouncer(handleEditorChange);

  const handleDebounceValue = (value) => {
    setEditorValue(value);
    debouncer(value);
  };

  function handleEditorChange(value) {
    const parsedQuery = value.replace(/\\r\\n/g, "");
    formRef?.setFieldValue("payload", parsedQuery);
  }

  useEffect(() => {
    document.body.style.overflow = editorExpanded ? "hidden" : "";
  }, [editorExpanded]);

  const renderEditor = (
    <EditorInput
      fieldValue={editorValue}
      language="json"
      onChange={handleDebounceValue}
      options={{
        wordWrap: "off",
        scrollbar: {
          vertical: "auto",
          horizontal: "auto",
          verticalScrollbarSize: 8
        },
        readOnly: isFlowActive || !allowEditWorkflow
      }}
      height={editorExpanded ? "100%" : "300px"}
    />
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }}
    >
      <SoftTypography
        sx={{ paddingLeft: 2, paddingBottom: 1 }}
        variant="caption"
        fontWeight="light"
        color="dark"
      >
        Response
      </SoftTypography>

      {/* Regular mode */}
      {!editorExpanded && (
        <SoftBox sx={{ position: "relative" }}>
          {renderEditor}
          <EditorExpansion
            isExpanded={editorExpanded}
            handleExpansion={() => setEditorExpanded(true)}
          />
        </SoftBox>
      )}

      {/* Fullscreen mode */}
      {editorExpanded &&
        createPortal(
          <SoftBox
            sx={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 99999,
              backgroundColor: "rgba(20, 20, 20, 1)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <SoftBox sx={{ flex: 1, position: "relative" }}>
              {renderEditor}
              <SoftBox
                sx={{
                  position: "absolute",
                  bottom: 16,
                  right: 16,
                  zIndex: 100000
                }}
              >
                <EditorExpansion
                  isExpanded={editorExpanded}
                  handleExpansion={() => setEditorExpanded(false)}
                />
              </SoftBox>
            </SoftBox>
          </SoftBox>,
          document.body
        )}
    </div>
  );
};

export default PayloadEditor;
